import type { VendingTable } from "./vendingTable";
import { Cannon } from "../weapons/cannon.ts";
import { LandmineWeapon } from "../weapons/landmineWeapon.ts";
import { MissileGun } from "../weapons/missileGun.ts";
import { LaserGun } from "../weapons/laserGun.ts";
import { DrillLauncher } from "../weapons/drillLauncher.ts";
import { Medikit } from "../items/medikit.ts";
import { Key } from "../items/key.ts";
import { getReferencePrice } from "../economy/itemReferencePrices.ts";
import { Flamethrower } from "../weapons/flamethrower.ts";
import { GasBombWeapon } from "../weapons/gasBombWeapon.ts";
import { BarrierGun } from "../weapons/barrierGun.ts";
import { MissileBurst } from "../weapons/missileBurst.ts";
import { CannonBurst } from "../weapons/cannonBurst.ts";
import { Jetpack } from "../weapons/jetpack.ts";
import { PlasmaGun } from "../weapons/plasmaGun.ts";

export const ProdVendingTables = {
	getEarlyGame(): VendingTable {
		return {
			entries: [
				{ itemKey: Cannon.key, packSize: 10, price: getReferencePrice(Cannon.key) * 10, stock: 15, weight: 999 },
				{
					itemKey: LandmineWeapon.key,
					packSize: 10,
					price: getReferencePrice(LandmineWeapon.key) * 10,
					stock: 15,
					weight: 2,
				},
				{ itemKey: MissileGun.key, packSize: 5, price: getReferencePrice(MissileGun.key) * 5, stock: 15, weight: 2 },
				{ itemKey: Medikit.key, packSize: 1, price: getReferencePrice(Medikit.key) * 1, stock: 1, weight: 999 },
				{ itemKey: Key.key, packSize: 1, price: getReferencePrice(Key.key) * 1, stock: 4, weight: 1 },
			],
			pickCount: 10,
		};
	},
	getLateWasteland(): VendingTable {
		return {
			entries: [
				{ itemKey: Cannon.key, packSize: 10, price: getReferencePrice(Cannon.key) * 10, stock: 20, weight: 999 },
				{ itemKey: CannonBurst.key, packSize: 5, price: getReferencePrice(Cannon.key) * 5, stock: 10, weight: 999 },
				{
					itemKey: LandmineWeapon.key,
					packSize: 10,
					price: getReferencePrice(LandmineWeapon.key) * 10,
					stock: 20,
					weight: 2,
				},
				{ itemKey: MissileGun.key, packSize: 5, price: getReferencePrice(MissileGun.key) * 5, stock: 15, weight: 2 },
				{
					itemKey: DrillLauncher.key,
					packSize: 5,
					price: getReferencePrice(DrillLauncher.key) * 5,
					stock: 15,
					weight: 2,
				},
				{ itemKey: BarrierGun.key, packSize: 5, price: getReferencePrice(BarrierGun.key) * 5, stock: 15, weight: 2 },
				{
					itemKey: GasBombWeapon.key,
					packSize: 1,
					price: getReferencePrice(GasBombWeapon.key) * 1,
					stock: 5,
					weight: 2,
				},
				{ itemKey: LaserGun.key, packSize: 5, price: getReferencePrice(LaserGun.key) * 5, stock: 10, weight: 2 },
				{
					itemKey: Flamethrower.key,
					packSize: 5,
					price: getReferencePrice(Flamethrower.key) * 5,
					stock: 10,
					weight: 2,
				},
				{ itemKey: Medikit.key, packSize: 1, price: getReferencePrice(Medikit.key) * 1, stock: 2, weight: 999 },
				{ itemKey: Key.key, packSize: 1, price: getReferencePrice(Key.key) * 1, stock: 4, weight: 1 },
			],
			pickCount: 99,
		};
	},
	getEarlyCaves(): VendingTable {
		return {
			entries: [
				{
					itemKey: Cannon.key,
					packSize: 10,
					price: getReferencePrice(Cannon.key) * 10,
					stock: 20,
					weight: 999,
				},
				{
					itemKey: CannonBurst.key,
					packSize: 5,
					price: getReferencePrice(CannonBurst.key) * 5,
					stock: 10,
					weight: 999,
				},
				{
					itemKey: LandmineWeapon.key,
					packSize: 10,
					price: getReferencePrice(LandmineWeapon.key) * 10,
					stock: 20,
					weight: 2,
				},
				{
					itemKey: MissileGun.key,
					packSize: 5,
					price: getReferencePrice(MissileGun.key) * 5,
					stock: 15,
					weight: 2,
				},
				{
					itemKey: MissileBurst.key,
					packSize: 1,
					price: getReferencePrice(MissileBurst.key) * 1,
					stock: 5,
					weight: 2,
				},
				{
					itemKey: DrillLauncher.key,
					packSize: 5,
					price: getReferencePrice(DrillLauncher.key) * 5,
					stock: 15,
					weight: 2,
				},
				{ itemKey: BarrierGun.key, packSize: 5, price: getReferencePrice(BarrierGun.key) * 5, stock: 15, weight: 2 },
				{
					itemKey: GasBombWeapon.key,
					packSize: 1,
					price: getReferencePrice(GasBombWeapon.key) * 1,
					stock: 5,
					weight: 2,
				},
				{
					itemKey: LaserGun.key,
					packSize: 5,
					price: getReferencePrice(LaserGun.key) * 5,
					stock: 10,
					weight: 2,
				},
				{
					itemKey: Flamethrower.key,
					packSize: 5,
					price: getReferencePrice(Flamethrower.key) * 5,
					stock: 10,
					weight: 2,
				},
				{
					itemKey: PlasmaGun.key,
					packSize: 5,
					price: getReferencePrice(PlasmaGun.key) * 5,
					stock: 10,
					weight: 2,
				},
				{ itemKey: Medikit.key, packSize: 1, price: getReferencePrice(Medikit.key) * 1, stock: 2, weight: 999 },
				{ itemKey: Key.key, packSize: 1, price: getReferencePrice(Key.key) * 1, stock: 4, weight: 1 },
				{ itemKey: Jetpack.key, packSize: 1, price: getReferencePrice(Jetpack.key) * 1, stock: 4, weight: 1 },
			],
			pickCount: 99,
		};
	},
	getLateCaves(): VendingTable {
		return {
			entries: [
				{
					itemKey: Cannon.key,
					packSize: 10,
					price: getReferencePrice(Cannon.key) * 10,
					stock: 20,
					weight: 999,
				},
				{
					itemKey: CannonBurst.key,
					packSize: 5,
					price: getReferencePrice(CannonBurst.key) * 5,
					stock: 10,
					weight: 999,
				},
				{
					itemKey: LandmineWeapon.key,
					packSize: 10,
					price: getReferencePrice(LandmineWeapon.key) * 10,
					stock: 20,
					weight: 2,
				},
				{
					itemKey: MissileGun.key,
					packSize: 5,
					price: getReferencePrice(MissileGun.key) * 5,
					stock: 15,
					weight: 2,
				},
				{
					itemKey: MissileBurst.key,
					packSize: 1,
					price: getReferencePrice(MissileBurst.key) * 1,
					stock: 5,
					weight: 2,
				},
				{
					itemKey: DrillLauncher.key,
					packSize: 5,
					price: getReferencePrice(DrillLauncher.key) * 5,
					stock: 15,
					weight: 2,
				},
				{ itemKey: BarrierGun.key, packSize: 5, price: getReferencePrice(BarrierGun.key) * 5, stock: 15, weight: 2 },
				{
					itemKey: GasBombWeapon.key,
					packSize: 1,
					price: getReferencePrice(GasBombWeapon.key) * 1,
					stock: 5,
					weight: 2,
				},
				{
					itemKey: LaserGun.key,
					packSize: 5,
					price: getReferencePrice(LaserGun.key) * 5,
					stock: 10,
					weight: 2,
				},
				{
					itemKey: Flamethrower.key,
					packSize: 5,
					price: getReferencePrice(Flamethrower.key) * 5,
					stock: 10,
					weight: 2,
				},
				{
					itemKey: PlasmaGun.key,
					packSize: 5,
					price: getReferencePrice(PlasmaGun.key) * 5,
					stock: 10,
					weight: 2,
				},
				{ itemKey: Medikit.key, packSize: 1, price: getReferencePrice(Medikit.key) * 1, stock: 2, weight: 999 },
				{ itemKey: Key.key, packSize: 1, price: getReferencePrice(Key.key) * 1, stock: 4, weight: 1 },
				{ itemKey: Jetpack.key, packSize: 1, price: getReferencePrice(Jetpack.key) * 1, stock: 4, weight: 1 },
			],
			pickCount: 99,
		};
	},
	getRobotBase(): VendingTable {
		return {
			entries: [
				{
					itemKey: Cannon.key,
					packSize: 10,
					price: getReferencePrice(Cannon.key) * 10,
					stock: 20,
					weight: 999,
				},
				{
					itemKey: CannonBurst.key,
					packSize: 5,
					price: getReferencePrice(CannonBurst.key) * 5,
					stock: 10,
					weight: 999,
				},
				{
					itemKey: LandmineWeapon.key,
					packSize: 10,
					price: getReferencePrice(LandmineWeapon.key) * 10,
					stock: 20,
					weight: 2,
				},
				{
					itemKey: MissileGun.key,
					packSize: 5,
					price: getReferencePrice(MissileGun.key) * 5,
					stock: 15,
					weight: 2,
				},
				{
					itemKey: MissileBurst.key,
					packSize: 1,
					price: getReferencePrice(MissileBurst.key) * 1,
					stock: 5,
					weight: 2,
				},
				{
					itemKey: DrillLauncher.key,
					packSize: 5,
					price: getReferencePrice(DrillLauncher.key) * 5,
					stock: 15,
					weight: 2,
				},
				{ itemKey: BarrierGun.key, packSize: 5, price: getReferencePrice(BarrierGun.key) * 5, stock: 15, weight: 2 },
				{
					itemKey: GasBombWeapon.key,
					packSize: 1,
					price: getReferencePrice(GasBombWeapon.key) * 1,
					stock: 5,
					weight: 2,
				},
				{
					itemKey: LaserGun.key,
					packSize: 5,
					price: getReferencePrice(LaserGun.key) * 5,
					stock: 10,
					weight: 2,
				},
				{
					itemKey: Flamethrower.key,
					packSize: 5,
					price: getReferencePrice(Flamethrower.key) * 5,
					stock: 10,
					weight: 2,
				},
				{
					itemKey: PlasmaGun.key,
					packSize: 5,
					price: getReferencePrice(PlasmaGun.key) * 5,
					stock: 10,
					weight: 2,
				},
				{ itemKey: Medikit.key, packSize: 1, price: getReferencePrice(Medikit.key) * 1, stock: 4, weight: 999 },
				{ itemKey: Key.key, packSize: 1, price: getReferencePrice(Key.key) * 1, stock: 4, weight: 1 },
				{ itemKey: Jetpack.key, packSize: 1, price: getReferencePrice(Jetpack.key) * 1, stock: 4, weight: 1 },
			],
			pickCount: 99,
		};
	},
};
